










import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import Loading from '@/components/loading/Loading.vue';
import OwnerFormController from "./components/owner-form/OwnerFormController.vue";
import FarmsListController from "./components/farms-list/FarmsListController.vue";
import FarmController from "./components/farm-controller/FarmController.vue";
import AnalysisModalController from '@/components/analysisModal/AnalysisModalController.vue';
import * as ownerService from "@/services/owner";
import { Owner } from "@/api/owner/types";
import { Farm } from "@/api/farms/types";
import * as farmService from "@/services/farms";


@Component({
  name: "Farms",
  components: {
    OwnerFormController,
    FarmsListController,
    FarmController,
    AnalysisModalController,
    Loading,
  }
})
export default class Farms extends Vue {
  @Prop(String)
  private ownerUuid?: string;

  private farmTo: Farm | null = null;

  private analysisTypeTo: string | null = null;

  private analysisModal: boolean = false;

  private farmCreationState: string = "closed";

  private loadingKey = 0;

  private async beforeMount() {
    if (!this.ownerUuid || this.ownerUuid === '') {
        await farmService.clearFarms();
    }
  }

  get isLoading() {
    const isLoadingOwner = this.$store.getters['owner/isLoadingOwner'];
    const isLoadingFarms = this.$store.state.farms.status === 'fetching:farms';
    const isCreatingFarms = this.$store.state.farms.createStatus === 'submitting:farm';
    const isCreatingAnalysis = this.$store.state.analyses.createStatus === 'submitting:analysis';

    return (isLoadingOwner || isLoadingFarms || isCreatingFarms || isCreatingAnalysis);
  }

  @Watch('isLoading')
  private changedLoading() {
    this.loadingKey += 1;
  }

  private startFarmCreation() {
    this.farmCreationState = "initial";
  }

  private getFarmForAnalysis(farm: Farm) {
    this.analysisModal = true;
    this.farmTo = farm;
  }

  private getAnalysisType(analysisType: string) {
    this.analysisTypeTo = analysisType;
  }

  private closeCreateAnalysis() {
    this.analysisModal = false;
    this.farmTo = null;
  }

}
